import {
    type CaregiverPointSourceType,
    type OrganizationFeatures,
} from '@libraries/typescript/api_client';

export const CAREGIVER_POINTS_FEATURE_KEY = 'caregiver_points_enabled';

const CAREGIVER_POINT_SOURCE_LABELS: Record<CaregiverPointSourceType, string> =
    {
        shift_confirmed: 'Shift confirmed',
        callout_pickup: 'Callout pickup',
        clock_in_on_time: 'On-time clock-in',
        shift_completed: 'Shift completed',
        manual_adjustment: 'Manual adjustment',
        csv_import_reconciliation: 'CSV reconciliation',
    };

export function getCaregiverPointSourceLabel(
    sourceType: CaregiverPointSourceType,
): string {
    return CAREGIVER_POINT_SOURCE_LABELS[sourceType];
}

export function isCaregiverPointsEnabled(
    features: OrganizationFeatures | null | undefined,
): boolean {
    return features?.[CAREGIVER_POINTS_FEATURE_KEY] === true;
}
